import { put, select, takeLatest } from 'redux-saga/effects';
import api from '../../utils/api';
import { toastResponseError } from '../../utils/responseMessageHelper';
import {
  GET_KNOWLEDGE_BASE,
  putKnowledgeBaseFinishFetch,
  putKnowledgeBaseSectionContent,
  putKnowledgeBaseSectionContentsLoaded,
  putKnowledgeBaseSections,
  putKnowledgeBaseStartFetch,
} from '../reducers/help';
import { authSelectLocale } from '../selectors/globalSelectors';
import { helpSelectKnowledgeBaseLocaleLoaded } from '../selectors/helpSelectors';
import { loadKBTree } from './kbTreeLoader';

const HELP_KB_CONFIG = {
  apiFns: {
    getSections: api.help.getKnowledgeBase,
    getSectionContent: api.help.getKnowledgeBaseSection,
  },
  actions: {
    putSections: putKnowledgeBaseSections,
    putSectionContent: putKnowledgeBaseSectionContent,
    putContentsLoaded: putKnowledgeBaseSectionContentsLoaded,
  },
};

/* worker-saga */
function* onGetKnowledgeBase({ payload }) {
  try {
    const currentLocale = yield select(authSelectLocale);
    const kbLocaleLoaded = yield select(helpSelectKnowledgeBaseLocaleLoaded);

    if (currentLocale && currentLocale !== kbLocaleLoaded) {
      yield put(putKnowledgeBaseStartFetch());
      yield* loadKBTree({ ...HELP_KB_CONFIG, currentLocale });
    }
  } catch (response) {
    yield put(putKnowledgeBaseFinishFetch());
    toastResponseError(response);
  }
}

/* watcher-saga */
function* watchHelpActions() {
  yield takeLatest(GET_KNOWLEDGE_BASE, onGetKnowledgeBase);
}

export default watchHelpActions;
